<template>
  <div class="pa-3">
    <div class="d-flex">
      <h3>Planner Groups</h3>
      <v-spacer />
      <v-btn color="primary" flat @click="createPlannerGroup">
        <v-icon class="mr-1">mdi-plus</v-icon>PlannerGroup
      </v-btn>
    </div>
    <div
      v-for="plannerGroup in plannerGroups"
      :key="plannerGroup.id"
      class="d-flex align-center mt-2"
    >
      <v-row no-gutters>
        <v-col cols="3">
          <v-text-field
            v-model="plannerGroup.name"
            label="Name"
            variant="outlined"
            density="compact"
            hide-details
            @update:focused="!$event && plannerGroup.save()"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="plannerGroup.code"
            label="Code"
            variant="outlined"
            density="compact"
            hide-details
            @update:focused="!$event && plannerGroup.save()"
          />
        </v-col>
      </v-row>
      <v-btn
        class="ml-2"
        icon="mdi-delete"
        flat
        density="compact"
        @click="deletePlannerGroup(plannerGroup)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PlannerGroup } from "@/classes";
import { useConfirmStore } from "@/store/confirm";
import { useListStore } from "@/store/lists";
import { onMounted, onUnmounted, ref } from "vue";

const $confirm = useConfirmStore();
const lists = useListStore();

const plannerGroups = ref<PlannerGroup[]>([]);
onMounted(async () => {
  plannerGroups.value = await PlannerGroup.list();
  plannerGroups.value.sort((a, b) => a.created.getTime() - b.created.getTime());
});
onUnmounted(() => {
  lists.refreshList("plannerGroups");
});

const createPlannerGroup = async () => {
  const newPlannerGroup = new PlannerGroup();
  await newPlannerGroup.save();
  plannerGroups.value.push(newPlannerGroup);
};

const deletePlannerGroup = async (plannerGroup: PlannerGroup) => {
  $confirm.open({
    onConfirm: async () => {
      plannerGroups.value = plannerGroups.value.filter(
        (d) => d.id !== plannerGroup.id
      );
      await plannerGroup.deleteObject();
    },
  });
};
</script>
